import React from 'react';

import { Box, ContentLayoutF, Spinner, Text } from '@betterment/samba-react';
import { useFeatureFlag } from '@betterment/shared-components';

import { ClientAgreementsCard } from './ClientAgreementsCard';
import { ClientAgreementsSignatureHeader } from './ClientAgreementsSignatureHeader';

import { Layout } from '../InstitutionalApp/Layout';

export const ClientAgreementSignaturesPage: React.FC = () => {
  const { enabled: isReactAgreementsPageEnabled, loading } = useFeatureFlag({
    splitName: 'retail.b4a_ax_switch_institutional_agreements_page_react_q2_2026_enabled',
    context: 'ClientAgreementSignaturesPage',
  });

  if (!loading && !isReactAgreementsPageEnabled) {
    window.location.reload();
  }

  const shouldShowLegacyAgreementsPage = loading || !isReactAgreementsPageEnabled;

  return (
    <Layout active="agreements">
      <Layout.Header>
        <ClientAgreementsSignatureHeader isLegacyAgreementsPage={shouldShowLegacyAgreementsPage} />
      </Layout.Header>
      <Layout.Content>
        {shouldShowLegacyAgreementsPage ? (
          <Box css={{ display: 'flex', height: '100vh', justifyContent: 'center', alignItems: 'center' }}>
            <Spinner size="lg" variant="primary" />
          </Box>
        ) : (
          <ContentLayoutF
            css={{
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <ContentLayoutF.SlotContainer css={{ maxWidth: '1200px', flex: 1 }}>
              <ContentLayoutF.Slot1
                css={{ display: 'grid', gap: { base: 'space.100', sm: 'space.300' }, gridAutoRows: 'max-content' }}
              >
                <ClientAgreementsCard />
              </ContentLayoutF.Slot1>
              <ContentLayoutF.Slot2
                css={{ display: 'grid', gap: { base: 'space.100', sm: 'space.300' }, gridAutoRows: 'max-content' }}
              >
                <Text>Agreement automation</Text>
              </ContentLayoutF.Slot2>
            </ContentLayoutF.SlotContainer>
          </ContentLayoutF>
        )}
      </Layout.Content>
    </Layout>
  );
};
